import React, { useState } from "react";
import "./id-card-config.scss";


const StudyCertificate = () => {


    const StudyStudents = [

        {
            name: "U. Sathvika",
            father: "U. Raviteja",
            mother: "U. Naga Swetha",
            admission: "252628",
            className: "PP-1",
            section: "A",
            course: "PRE PRIMARY",
            dob: "09 Feb 2021",
            curriculum: "SSC",
            academicYear: "2026-27"
        },


        {
            name: "Rahul Kumar",
            father: "Ramesh Kumar",
            mother: "Sunita Kumar",
            admission: "252629",
            className: "1st",
            section: "B",
            course: "PRIMARY",
            dob: "14 Aug 2019",
            curriculum: "CBSE",
            academicYear: "2026-27"
        }

    ];



    const [searchStudent, setSearchStudent] = useState("");

    const [showStudentList, setShowStudentList] = useState(false);



    const [formData, setFormData] = useState({

        academicYear: "",
        curriculum: "",
        className: "",
        section: "",

        student: "",
        father: "",
        mother: "",
        admissionNo: "",
        course: "",
        dob: "",

        certificateNo: "SC/36/2026",

        issueDate: "2026-06-19",

        place: "Vijayawada",



        // Editable Certificate Content

        introText:
            "This is to certify that the following student has studied in our institution.",


        studyText:
            "The student has successfully completed the course of study during the academic year mentioned below.",


        courseText:
            "The student was enrolled in the above mentioned class and curriculum as per school records.",


        closingText:
            "This certificate is issued on the request of the student/parent for official purpose."

    });





    const handleChange = (e) => {


        const { name, value } = e.target;


        setFormData(prev => ({

            ...prev,

            [name]: value

        }));

    }





    const selectStudent = (stu) => {


        setFormData(prev => ({

            ...prev,

            student: stu.name,

            father: stu.father,

            mother: stu.mother,

            admissionNo: stu.admission,

            className: stu.className,

            section: stu.section,

            course: stu.course,

            dob: stu.dob,

            curriculum: stu.curriculum,

            academicYear: stu.academicYear


        }));


        setSearchStudent(stu.name);

        setShowStudentList(false);


    }





    const filteredStudents = StudyStudents.filter(item =>

        item.name
            .toLowerCase()
            .includes(searchStudent.toLowerCase())

    );





    const displayValue = (value) => {


        return value && value.toString().trim() !== ""


            ?

            value


            :

            "________";


    }






    return (


        <div className="container-fluid mt-3">





            {/* FILTER */}


            <div className="card no-print">


                <div className="card-header">

                    Generate Study Certificate

                </div>


                <div className="card-body">


                    <div className="row g-3">





                        <div className="col-md-3">

                            <label>
                                Academic Year
                            </label>


                            <select

                                className="form-select"

                                name="academicYear"

                                value={formData.academicYear}

                                onChange={handleChange}

                            >


                                <option value="">
                                    Select
                                </option>

                                <option>
                                    2026-27
                                </option>

                                <option>
                                    2025-26
                                </option>


                            </select>

                        </div>





                        <div className="col-md-3">

                            <label>
                                Curriculum
                            </label>


                            <select

                                className="form-select"

                                name="curriculum"

                                value={formData.curriculum}

                                onChange={handleChange}

                            >

                                <option value="">
                                    Select
                                </option>

                                <option>
                                    SSC
                                </option>

                                <option>
                                    CBSE
                                </option>


                            </select>


                        </div>





                        <div className="col-md-3">

                            <label>
                                Class
                            </label>


                            <select

                                className="form-select"

                                name="className"

                                value={formData.className}

                                onChange={handleChange}

                            >

                                <option value="">
                                    Select
                                </option>

                                <option>
                                    PP-1
                                </option>

                                <option>
                                    PP-2
                                </option>

                                <option>
                                    1st
                                </option>

                                <option>
                                    2nd
                                </option>


                            </select>

                        </div>





                        <div className="col-md-3">

                            <label>
                                Section
                            </label>


                            <select

                                className="form-select"

                                name="section"

                                value={formData.section}

                                onChange={handleChange}

                            >


                                <option value="">
                                    Select
                                </option>

                                <option>
                                    A
                                </option>

                                <option>
                                    B
                                </option>


                            </select>


                        </div>







                        <div className="col-md-3 position-relative">


                            <label>
                                Student
                            </label>


                            <input

                                className="form-control"

                                value={searchStudent}

                                onChange={(e) => {

                                    setSearchStudent(e.target.value);

                                    setShowStudentList(true);

                                }}

                                onFocus={() => setShowStudentList(true)}

                            />



                            {

                                showStudentList && searchStudent &&


                                <div className="student-list">


                                    {

                                        filteredStudents.map((stu, index) => (


                                            <div

                                                key={index}

                                                onMouseDown={() => selectStudent(stu)}

                                            >


                                                <b>{stu.name}</b>

                                                <br />

                                                Father :
                                                {stu.father}


                                            </div>


                                        ))


                                    }


                                </div>


                            }


                        </div>





                        <div className="col-md-3">

                            <label>
                                Certificate No
                            </label>

                            <input

                                className="form-control"

                                name="certificateNo"

                                value={formData.certificateNo}

                                onChange={handleChange}

                            />

                        </div>




                        <div className="col-md-3">

                            <label>
                                Issue Date
                            </label>


                            <input

                                type="date"

                                className="form-control"

                                name="issueDate"

                                value={formData.issueDate}

                                onChange={handleChange}

                            />


                        </div>




                        <div className="col-md-3">

                            <label>
                                Place
                            </label>

                            <input

                                className="form-control"

                                name="place"

                                value={formData.place}

                                onChange={handleChange}

                            />

                        </div>





                        {/* EDITABLE CONTENT */}



                        <div className="col-md-6">

                            <label>
                                Opening Content
                            </label>


                            <textarea

                                className="form-control"

                                rows="2"

                                name="introText"

                                value={formData.introText}

                                onChange={handleChange}

                            />

                        </div>





                        <div className="col-md-6">

                            <label>
                                Study Content
                            </label>


                            <textarea

                                className="form-control"

                                rows="2"

                                name="studyText"

                                value={formData.studyText}

                                onChange={handleChange}

                            />

                        </div>





                        <div className="col-md-6">

                            <label>
                                Course Content
                            </label>


                            <textarea

                                className="form-control"

                                rows="2"

                                name="courseText"

                                value={formData.courseText}

                                onChange={handleChange}

                            />

                        </div>





                        <div className="col-md-6">

                            <label>
                                Closing Content
                            </label>


                            <textarea

                                className="form-control"

                                rows="2"

                                name="closingText"

                                value={formData.closingText}

                                onChange={handleChange}

                            />

                        </div>



                    </div>


                </div>


            </div>








            {/* CERTIFICATE */}



            <div className="print-area">


                <div className="certificate">


                    <div className="certificate-border">



                        <div className="school-header">


                            <img

                                src="https://www.srinitheplayschool.com/img/logo.png"

                                className="school-logo"

                            />


                            <div>

                                <h2>
                                    SRINI THE PLAY SCHOOL & ACADEMY
                                </h2>


                                <p>
                                    Vijayawada, Andhra Pradesh
                                    <br />
                                    Contact : 7893077007
                                </p>


                            </div>


                        </div>





                        <h1>
                            STUDY CERTIFICATE
                        </h1>
                        


                        <div className="certificate-body">


                            <p>

                                Certificate No :

                                <b>
                                    {displayValue(formData.certificateNo)}
                                </b>


                            </p>



                            <p>

                                {formData.introText}

                            </p>





                            <p>


                                This is to certify that

                                <b>
                                    &nbsp;{displayValue(formData.student)}
                                </b>


                                son/daughter of


                                <b>
                                    &nbsp;{displayValue(formData.father)}
                                </b>


                                and


                                <b>
                                    &nbsp;{displayValue(formData.mother)}
                                </b>


                                bearing Admission No.


                                <b>
                                    &nbsp;{displayValue(formData.admissionNo)}
                                </b>


                            </p>





                            <p>


                                {formData.courseText}


                            </p>





                            <p>


                                Class :

                                <b>
                                    {displayValue(formData.className)}
                                    -
                                    {displayValue(formData.section)}
                                </b>


                                Curriculum :

                                <b>
                                    {displayValue(formData.curriculum)}
                                </b>


                            </p>





                            <p>

                                Date of Birth :

                                <b>
                                    {displayValue(formData.dob)}
                                </b>


                            </p>





                            <p>


                                Academic Year :

                                <b>
                                    {displayValue(formData.academicYear)}
                                </b>


                            </p>





                            <p>

                                {formData.studyText}

                            </p>



                            <p>

                                {formData.closingText}

                            </p>



                        </div>







                        <div className="certificate-footer">


                            <div>


                                Date :

                                {formData.issueDate}


                                <br />


                                Place :

                                {formData.place}


                            </div>




                            <div>


                                _________________

                                <br />

                                PRINCIPAL


                            </div>


                        </div>






                    </div>


                </div>


            </div>





            <div className="no-print text-center">


                <button

                    className="btn btn-success mt-3"

                    onClick={() => window.print()}

                >

                    Print Certificate

                </button>


            </div>



        </div>


    )

}


export default StudyCertificate;